'use client'

import { useTranslation } from 'react-i18next'

export default function LegalTranslationNotice() {
  const { t } = useTranslation()

  return (
    <div className="mb-8 rounded-lg border border-white/10 bg-white/5 p-4 text-sm text-gray-200">
      <p className="font-semibold text-white">
        {t('legalTranslationNoticeTitle')}
      </p>
      <p className="mt-1 text-gray-300">{t('legalTranslationNoticeBody')}</p>
    </div>
  )
}
